const zIndex = {
  min: -9999,
  hide: -1000,
  base: 0,
  primary: 1000,
  secondary: 2000,
  tertiary: 3000,
  footer: 4000,
  header: 5000,
  dropdown: 6000,
  overlay: 7000,
  drawer: 8000,
  modal: 9000,
  max: 9999,
}

export default zIndex
